import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';
import { Step } from '../Step';
import styles from './style.css';
import { IMortgageStep } from '../../types/proposal';

export interface IMortgageStepsProps {
  steps: IMortgageStep[];
  detailsLink?: string;
}

export const MortgageSteps: React.FC<IMortgageStepsProps> = ({ detailsLink, steps }) => {
  return (
    <div className={styles['wrapper']}>
      <UIHeading1>Как это работает</UIHeading1>
      <ol className={styles['container']}>
        {steps.map(step => (
          <li key={step.title}>
            <Step step={step} />
          </li>
        ))}
      </ol>
      {detailsLink && (
        <a className={styles['about-link']} href={detailsLink}>
          Подробнее о программе
        </a>
      )}
    </div>
  );
};
